import { Step } from 'react-joyride';
import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface TourState {
  run: boolean;
  stepIndex: number;
  steps: Step[];
  setSteps: (steps: Step[]) => void;
  startTour: () => void;
  stopTour: () => void;
  nextStep: () => void;
  prevStep: () => void;
  setStepIndex: (index: number) => void;
}

export const useTourStore = create<TourState>(set => ({
  run: false,
  stepIndex: 0,
  steps: [],
  setSteps: steps => set({ steps }),
  startTour: () => set({ run: true, stepIndex: 0 }),
  stopTour: () => set({ run: false, stepIndex: 0 }),
  nextStep: () => set(state => ({ stepIndex: state.stepIndex + 1 })),
  prevStep: () =>
    set(state => ({ stepIndex: Math.max(0, state.stepIndex - 1) })),
  setStepIndex: index => set({ stepIndex: index }),
}));

export type TourPhaseId =
  | 'FIRST_LOGIN'
  | 'AFTER_FIRST_CLASS'
  | 'AFTER_FIRST_QUIZ';

export interface TourPhaseProgress {
  id: TourPhaseId;
  profileId: string;
  lastViewedStepId: string | null;
}

interface TourStorageState {
  progress: TourPhaseProgress[];
  updateProgress: (id: TourPhaseId, profileId: string, stepId: string) => void;
  resetProgress: () => void;
}

export const useTourStorageStore = create<TourStorageState>()(
  persist(
    set => ({
      progress: [],

      updateProgress: (id, profileId, stepId) =>
        set(state => {
          const existingIndex = state.progress.findIndex(
            p => p.id === id && p.profileId === profileId
          );
          if (existingIndex !== -1) {
            const newProgress = [...state.progress];
            newProgress[existingIndex] = {
              ...newProgress[existingIndex],
              lastViewedStepId: stepId,
            };
            return { progress: newProgress };
          }
          return {
            progress: [
              ...state.progress,
              { id, profileId, lastViewedStepId: stepId },
            ],
          };
        }),

      resetProgress: () => set({ progress: [] }),
    }),
    {
      name: 'student-tour-progress',
    }
  )
);
